import React, { useContext } from 'react';
import { Button, Col, Row } from 'antd';
import PropTypes from 'prop-types';
import LegalRecordInfo from '../../LegalRecordInfo';
import LegalBackgroundForm from './LegalBackgroundForm';
import enrollmentAction from '../../../../../../providers/EnrollmentContextProvider/enrollmentAction';
import { EnrollmentContext } from '../../../../../../providers/EnrollmentContextProvider';

const LegalBackground = ({ onFinish }) => {
  const { dispatch, areLegalBackgroundInstructionRead } = useContext(EnrollmentContext);

  const acceptInstructions = () => {
    dispatch({ type: enrollmentAction.ACCEPT_LEGAL_BACKGROUND_INSTRUCCTIONS });
  };

  return (
    <div>
      {areLegalBackgroundInstructionRead ? (
        <LegalBackgroundForm onFinish={onFinish} />
      ) : (
        <div>
          <LegalRecordInfo />
          <Row>
            <Col lg={10} xs={24}>
              <Button
                className="enrollmentLegalFormContainer__button"
                type="primary"
                onClick={() => acceptInstructions()}
              >
                Entendido
              </Button>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

LegalBackground.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default LegalBackground;
